@let blok = block();
@if (env.preview || blok.disableSectionLazyLoading) {
    @for (child of blok.children; track child._uid) {
        <s1-cms-component [blok]="child"/>
    }
} @else {
    @defer (hydrate on interaction) {
        @for (child of blok.children; track child._uid) {
            <s1-cms-component [blok]="child"/>
        }
    }
}
